import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { getTotalItems } = useCart();
  const totalItems = getTotalItems();

  return (
    <header className="bg-[#8e0707] py-6 px-8 md:px-[140px]">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src="/Logo.png" alt="Sunkissed Pickles" className="h-10 md:h-12 filter brightness-0 invert" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
        <Link to="/" className={`font-sans text-white text-base ${location.pathname === '/' ? '' : 'opacity-60'} hover:opacity-100`}>
          Home
        </Link>
        <Link to="/about" className={`font-sans text-white text-base ${location.pathname === '/about' ? '' : 'opacity-60'} hover:opacity-100`}>
          About
        </Link>
        <Link to="/products" className={`font-sans text-white text-base ${location.pathname === '/products' ? '' : 'opacity-60'} hover:opacity-100 flex items-center gap-1`}>
          Products
          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </Link>
        <Link to="/partner" className={`font-sans text-white text-base ${location.pathname === '/partner' ? '' : 'opacity-60'} hover:opacity-100`}>
          Be a partner
        </Link>
      </nav>

        <div className="flex items-center gap-4 md:gap-6">
          <Link to="/cart" className="relative">
            <svg className="w-5 h-5 text-white cursor-pointer" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.68 8.32a2 2 0 002 1.68h9.36a2 2 0 002-1.68L17 13" />
            </svg>
            {totalItems > 0 && (
              <span className="absolute -top-2 -right-2 bg-white text-[#8e0707] text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
                {totalItems}
              </span>
            )}
          </Link>
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-white">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <nav className="md:hidden mt-4 flex flex-col gap-4">
          <Link to="/" onClick={() => setIsMenuOpen(false)} className={`text-white text-base ${location.pathname === '/' ? '' : 'opacity-60'}`}>
            Home
          </Link>
          <Link to="/about" onClick={() => setIsMenuOpen(false)} className={`text-white text-base ${location.pathname === '/about' ? '' : 'opacity-60'}`}>
            About
          </Link>
          <Link to="/products" onClick={() => setIsMenuOpen(false)} className={`text-white text-base ${location.pathname === '/products' ? '' : 'opacity-60'}`}>
            Products
          </Link>
          <Link to="/partner" onClick={() => setIsMenuOpen(false)} className={`text-white text-base ${location.pathname === '/partner' ? '' : 'opacity-60'}`}>
            Be a partner
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;